import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=1563ff74"
import script from "./ProfileDetail.vue?vue&type=script&lang=ts"
export * from "./ProfileDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1563ff74')) {
      api.createRecord('1563ff74', component.options)
    } else {
      api.reload('1563ff74', component.options)
    }
    module.hot.accept("./ProfileDetail.vue?vue&type=template&id=1563ff74", function () {
      api.rerender('1563ff74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileDetail.vue"
export default component.exports